
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","height":"16","width":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000000","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.54 2.556l4.973 4.973c.261.26.261.682 0 .942l-4.972 4.973a.666.666 0 01-.943 0L.625 8.471a.666.666 0 010-.942l4.973-4.973c.26-.26.683-.26.943 0zM15.07 3h-2.5v2.5M12.57 10.5V13h2.5","stroke-width":"1.000005"}}),_c('path',{attrs:{"d":"M12.57 3l1.681 1.768a4.5 4.5 0 010 6.364s0 0 0 0l-1.682 1.867","stroke-width":"1.000005"}})])])
          )
        }
      }
    